<template>
  <div>
    <div v-if="formKey === 'unit_names'">
      <div class="flex items-center">
        <el-button v-if="!formItem.isPreview" type="primary" @click="() => openUnitNames(formItem)">添加自定义名称</el-button>
        <i v-if="Object.keys(formItem.value || {}).length" class="el-icon-success app-check-icon-success" :class="{ 'ml-10': !formItem.isPreview }" />
      </div>
      <div v-if="!Object.keys(formItem.value || {}).length && formItem.isPreview">-</div>
      <el-dialog
        title="自定义单元名称配置"
        :visible.sync="formItem.is_open"
        :close-on-click-modal="false"
        :append-to-body="true"
        :modal-append-to-body="true"
        width="800px"
      >
        <unit-names :key="Date.now()" :form-item="formItem" />
        <span slot="footer" class="dialog-footer">
          <el-button size="mini" @click="formItem.is_open = false">取 消</el-button>
          <el-button size="mini" type="primary" @click="() => confirmUnitNames(formItem)">确 定</el-button>
        </span>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import { component_props } from '@/views/fusion/investment/intelligence-create/components/main-view/components/step-form/model/props';

export default {
  components: {
    'unit-names': () => import('./components/unit-names/index.vue'),
  },
  props: {
    ...component_props,
  },
  methods: {
    /**
     * 打开单元名称配置
     * @param form_item 表单项
     * @returns {void}
     */
    openUnitNames(form_item) {
      form_item.assignSelection = JSON.parse(JSON.stringify(form_item.value));
      form_item.is_open = true;
    },
    /**
     * 单元名称配置弹窗确认
     * @param form_item 表单项
     * @returns {void}
     */
    confirmUnitNames(form_item) {
      const result = JSON.parse(JSON.stringify(form_item.assignSelection));
      form_item.value = result;
      form_item.is_open = false;
      form_item.on?.change?.(form_item.value);
    },
  },
};
</script>
